import React, {Suspense, useEffect, useRef, useState } from 'react'
import { Canvas } from "@react-three/fiber";



import emailjs from 'emailjs-com'
import {notification} from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import { Fox } from "../models/Fox";

import Loader  from "./Loader";


const Contact = () => {
    const [currentAnimation, setCurrentAnimation] = useState("idle");
    useEffect(() => {
      const interval = setInterval(() => {
        setCurrentAnimation((prevAnimation) =>
          prevAnimation === "idle" ? "walk" : "idle"
        );
      }, 4000);
  
      return () => clearInterval(interval);
    }, []);
  const [isLoading,setIsLoading] = useState(false)
  const form =useRef();
  const sendEmail = (e) => {
    e.preventDefault();
    setIsLoading(true)
    emailjs.sendForm('service_i3xu18a', 'template_j1okjxw', form.current, 'I1fzgglL3LBAFmh-7')
      .then((result) => {
          setIsLoading(false)
          form.current.reset();
          notification.success({message : 'Your message was sent successfully '})
      }, (error) => {
          console.log(error.text);
      });
  };
  return (
    <div  className='relative flex lg:flex-row flex-col max-container'>
        <div  className='flex-1 min-w-[50%] flex flex-col'>
            <h3  >Want to know more or just chat? <br></br>You are welcome!</h3>
            <form
                ref={form}
                onSubmit={sendEmail}
                className='w-full flex flex-col gap-7 mt-14'
                >
                <label className='text-black-500 font-semibold'>
                    Name
                    <input
                    type='text'
                    name='name'
                    className='input'
                    placeholder='Donald'
                    required
                    />
                </label>
                <label className='text-black-500 font-semibold'>
                    Email
                    <input
                    type='email'
                    name='email'
                    className='input'
                    placeholder='president@gmail.com'
                    required
                    />
                </label>
                <label className='text-black-500 font-semibold'>
                    Your Message
                    <textarea
                    name='message'
                    rows='4'
                    className='textarea'
                    placeholder='Great Wall...'
                      
                    />
                </label>

                <button
                    type='submit'
                    className='btn'
                >
                    {
                        !isLoading ? 'Send': <LoadingOutlined />
                    }
                </button>
             </form>
        </div>
        <div className='lg:w-1/2 w-full lg:h-auto md:h-[550px] h-[350px]'>
        <Canvas
          camera={{
            position: [0, 0, 5],
            fov: 75,
            near: 0.1,
            far: 1000,
          }}
        >
          <directionalLight position={[0, 0, 1]} intensity={2.5} />
          <ambientLight intensity={1} />
          <pointLight position={[5, 10, 0]} intensity={2} />
          <spotLight
            position={[10, 10, 10]}
            angle={0.15}
            penumbra={1}
            intensity={2}
          />

          <Suspense fallback={<Loader />}>
            <Fox
              currentAnimation={currentAnimation}
              position={[0.5, 0.35, 0]}
              rotation={[12.629, -0.6, 0]}
              scale={[0.5, 0.5, 0.5]}
            />
          </Suspense>
        </Canvas>
      </div>
    </div>
  )
}

export default Contact